/* eslint-disable max-lines */
const dsBasicSizes = ['s', 'm', 'l'];

const CHECKBOX_VARIANT = {
  DEFAULT: 'variant-default',
  FOCUS: 'variant-focus',
  ACTIVE: 'variant-active',
  DISABLED: 'variant-disabled',
  ERROR: 'variant-error',
};
const checkboxVariants = [
  CHECKBOX_VARIANT.DEFAULT,
  CHECKBOX_VARIANT.FOCUS,
  CHECKBOX_VARIANT.ACTIVE,
  CHECKBOX_VARIANT.DISABLED,
  CHECKBOX_VARIANT.ERROR,
];

const COMBOBOX_VARIANT = {
  DEFAULT: 'variant-default',
  FOCUS: 'variant-focus-input',
  FOCUS_ICON: 'variant-focus-icon',
  ACTIVE: 'variant-active-input',
  ACTIVE_ICON: 'variant-active-icon',
  DISABLED: 'variant-disabled',
  ERROR: 'variant-error',
};

const comboBoxVariants = [
  COMBOBOX_VARIANT.DEFAULT,
  COMBOBOX_VARIANT.FOCUS,
  COMBOBOX_VARIANT.FOCUS_ICON,
  COMBOBOX_VARIANT.ACTIVE,
  COMBOBOX_VARIANT.ACTIVE_ICON,
  COMBOBOX_VARIANT.DISABLED,
  COMBOBOX_VARIANT.ERROR,
];

const orientation = ['horizontal', 'vertical'];

export { COMBOBOX_VARIANT as C, CHECKBOX_VARIANT as a, checkboxVariants as b, comboBoxVariants as c, dsBasicSizes as d, orientation as o };
//# sourceMappingURL=prop-types-cc01d273.js.map
